var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 19V16H14V14H17V11H19V14H22V16H19V19H17ZM1 16V10H0V8L1 3H16L17 8V10H16V13H14V10H10V16H1ZM3 14H8V10H3V14ZM1 2V0H16V2H1ZM2.05 8H14.95L14.35 5H2.65L2.05 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddBusiness);
export default __webpack_public_path__ + "static/media/icon_add_business.e3096da6f044bf55881bb80392b8d108.svg";
export { ForwardRef as ReactComponent };